import * as React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Brush,
} from "recharts";
import { IYearStatistics } from "../types";
import { CustomTooltipYear } from "../../../../share/components/CustomTooltip/CustomTooltip";
export interface IYearChartS {}
export interface IYearChart {
  data: IYearStatistics[];
}

export const style = {
  bottom: 0,
  left: 10,
  lineHeight: "24px",
};
export const styleNoData = {
  ...style,
  fontSize: "1.2rem",
};
export const noData = [
  { year: 0, ["No Data to Show"]: 0 },
  { year: 1, ["No Data to Show"]: 0 },
  { year: 2, ["No Data to Show"]: 0 },
  { year: 3, ["No Data to Show"]: 0 },
];
export class YearChart extends React.PureComponent<IYearChart, IYearChartS> {
  constructor(props: IYearChart) {
    super(props);
  }

  public getStartIndexYear() {
    const startIndex = this.props.data.length - 5;
    return this.props.data && startIndex > 0 ? startIndex : 0;
  }

  public render() {
    const data = this.props.data.map((d: any) => {
      d.Open = d.opened;
      d.Closed = d.closed;
      return d;
    });
    if (!data.length) {
      return <p>No Data to Show</p>;
    }
    return (
      <ResponsiveContainer width={"100%"} height={310}>
        <AreaChart height={400} data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip content={<CustomTooltipYear />} />
          <Area
            type="monotone"
            dataKey="Open"
            stroke="#2ABCCA"
            fill="#2ABCCA"
          />
          <Area
            type="monotone"
            dataKey="Closed"
            stroke="#E2BC2F"
            fill="#E2BC2F"
          />
          <Legend
            iconSize={10}
            width={300}
            height={10}
            layout="horizontal"
            wrapperStyle={this.props.data.length > 0 ? style : styleNoData}
          />
          <Brush
            dataKey="year"
            startIndex={this.getStartIndexYear()}
            height={30}
            stroke="#8884d8"
          />
        </AreaChart>
      </ResponsiveContainer>
    );
  }
}
export default YearChart;



// WEBPACK FOOTER //
// ./src/modules/Dashboard/Home/components/YearChart.tsx